import {Fragment} from "react";

export const QuotePlaceholderBlurImg = (props: {
  cls: string,
  num: number,
  opacity: number,
  img: string,
}) => {
  const {
    cls,
    num = 1,
    opacity = 1,
    img,
  } = props;

  const height = 1024;
  const bgcolor = "white";
  const blurPx = 4;

  const times = Array(+num).fill(1);

  return (

    <Fragment>
      {
        times.map((t, idx) => (
            <div key={idx} className={cls}>
              <div
                  className="pinout"
                  style={{
                    width: "100%",
                    height: +height,
                    background: bgcolor,
                    backgroundImage: `url('${img}')`,
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    marginBottom: 15,
                    filter: `blur(${blurPx}px)`,
                    opacity: opacity,
                  }}
              ></div>
            </div>
        ))
      }
    </Fragment>
  )
};
